export const engagementLandingPagesAppGroupIdLandingPageIdPreview =
  "/engagement/landing_pages/:app_group_id/:landing_page_bson_id/preview";
